import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) { setReady(true); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("id_token");
    }).finally(() => setReady(true));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("id_token", data.token);
      setUser(data.user);
      return data.user;
    };
    const register = async (email, password, name) => {
      const { data } = await api.post("/auth/register", { email, password, name });
      localStorage.setItem("id_token", data.token);
      setUser(data.user);
      return data.user;
    };
    const logout = () => { localStorage.removeItem("id_token"); setUser(null); api.post("/auth/logout").catch(() => {}); };
    const loginWithGoogle = () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUrl = window.location.origin + "/account";
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };
    const exchangeSession = async (sessionId) => {
      const { data } = await api.post("/auth/session", { session_id: sessionId });
      localStorage.setItem("id_token", data.token);
      setUser(data.user);
      return data.user;
    };
    return { user, ready, login, register, logout, loginWithGoogle, exchangeSession };
  }, [user, ready]);

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}
export const useAuth = () => useContext(AuthCtx);
